import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "overlay overlay-block card-rounded" }
const _hoisted_2 = { class: "overlay-layer card-rounded bg-none d-flex flex-column align-items-center justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "fs-1 text-primary mb-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "overlay-wrapper p-5 card",
        style: _normalizeStyle({background:_ctx.background})
      }, [
        _createElementVNode("div", {
          class: "card-body",
          style: _normalizeStyle({height:`${_ctx.height ? _ctx.height : '250px'}`})
        }, null, 4)
      ], 4),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        _hoisted_4
      ])
    ])
  ]))
}